var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.83 10.4808L7.60862 4.32837C7.31244 4.03638 6.68968 4.03638 6.39349 4.32837L0.17213 10.4808C-0.0959592 10.7464 -0.041263 11.1333 0.293654 11.346C0.630851 11.5599 1.11918 11.5142 1.38726 11.2498L7.00106 5.69765L12.6148 11.2498C12.8855 11.5157 13.374 11.5573 13.7085 11.346C14.0434 11.1333 14.0981 10.7464 13.83 10.4808Z",
    fill: "url(#paint0_linear_1996_41021)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8289 14.463L7.60754 8.31062C7.31135 8.01863 6.68859 8.01863 6.39245 8.31062L0.171094 14.463C-0.235109 14.8654 0.127751 15.4628 0.778661 15.4628H3.11167V20.3848C3.11167 20.7248 3.4595 21 3.88934 21H10.1107C10.5405 21 10.8884 20.7248 10.8884 20.3848V15.4628H13.2214C13.8723 15.4628 14.2351 14.8654 13.8289 14.463ZM0.292618 7.23662C0.629815 7.4499 1.11814 7.40544 1.38623 7.14047L7.00002 1.58828L12.6138 7.14047C12.8845 7.4063 13.373 7.44797 13.7074 7.23662C14.0423 7.02391 14.097 6.637 13.8289 6.37142L7.60759 0.218996C7.3114 -0.0729985 6.68864 -0.0729985 6.39251 0.218996L0.171146 6.37142C-0.096995 6.637 -0.0422988 7.02395 0.292618 7.23662Z",
    fill: "url(#paint1_linear_1996_41021)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1996_41021",
    x1: 7.00111,
    y1: 11.4812,
    x2: 7.00111,
    y2: 4.10939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#F0FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1996_41021",
    x1: 7.00002,
    y1: 21,
    x2: 7.00002,
    y2: 0.0000100136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.847ca67e8d4d764283a993cec023c0da.svg";
export { ForwardRef as ReactComponent };